import React, { useState } from 'react'
import about_styles from "./about.module.css"
import {AiOutlineDown, AiOutlineRight} from "react-icons/ai"
import styles from "../Profile/profile.module.css"
import { updatePost } from '../../utils/Fetch/fetch'
import { toast } from 'react-toastify'
import Loader from '../Loader/loader'
const About = () => {
  const [about, setAbout] = useState({about: ""})
  const [color, setColor] = useState(false)
  const [show, setShow] = useState(false)
  const [showLoader, setShowLoader] = useState(false);
  

  const handleSave = async () => {
    setShowLoader(true);
      if(about.about === "") {
        toast("Please fill your Professional summary!")
        setColor(false)
        setShowLoader(false);
        return;
      }
      const updatedata = async () => {
        let data = await updatePost(JSON.stringify({about:about.about}))
        return data;
      }

      let updatedData = await updatedata()

      if(updatedData.success===true){
        toast("Professional Summary is saved successfully!")
        setColor(true)
        setShow(false)
        setShowLoader(false);
      }else {
        toast("Something went wrong!")
        setShowLoader(false);
      }
  }
  return (
    <div>
        <nav className={styles.profile__nav} onClick={() => setShow(!show)}>
        <h3 style={{color : color===false ? "crimson" : 'grey'}}>Professional Summary</h3>
        <span>
          {show ? <span className={styles.updown__icon}><AiOutlineDown/></span> : <span className={styles.updown__icon}><AiOutlineRight/></span>}
        </span>
        </nav>

        {show && <div className={styles.profile__box}>
          <div className={about_styles.about__textarea}>
            <textarea maxLength={260} name="about" id="about" value={about.about} onChange={(e) => setAbout({about:e.target.value})} className={about_styles.about} placeholder="Enter your professional summary"
            />
            <div style={{verticalAlign:"bottom", color:"grey"}}>{about.about.length}/260</div>
          </div>
          <div className={styles.savebtn_box}>
          <button className={styles.savebtn} onClick={handleSave}>Save</button>
        </div>
        </div>
        }
    {showLoader && <Loader /> }
    </div>
  )
}

export default About